module.exports = __webpack_public_path__ + "static/media/DSC_0440.af501dd8.jpg";